import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
          isScrolled
            ? 'bg-white/95 backdrop-blur-md shadow-sm border-b border-background-200/70'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-10">
          <div className="flex items-center justify-between h-16 md:h-18">
            <Link
              to="/"
              className={`font-heading text-lg md:text-xl font-bold transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-foreground-950' : 'text-white'
              }`}
            >
              Superbuy Spreadsheet
            </Link>

            <div className="hidden md:flex items-center gap-6">
              <Link
                to="/"
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                  isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
                }`}
                style={{ fontFamily: 'var(--font-label)' }}
              >
                Home
              </Link>
              <Link
                to="/superbuy-sheet-guide"
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                  isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
                }`}
                style={{ fontFamily: 'var(--font-label)' }}
              >
                Complete Guide
              </Link>
              <Link
                to="/superbuy-spreadsheet-review"
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                  isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
                }`}
                style={{ fontFamily: 'var(--font-label)' }}
              >
                Review
              </Link>
              <Link
                to="/superbuy-spreadsheet-beginner-guide"
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer ${
                  isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
                }`}
                style={{ fontFamily: 'var(--font-label)' }}
              >
                Beginner Guide
              </Link>
              <div className="relative group">
                <button
                  className={`flex items-center gap-1.5 text-sm font-medium transition-colors duration-300 cursor-pointer ${
                    isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
                  }`}
                  style={{ fontFamily: 'var(--font-label)' }}
                >
                  Categories
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </button>
                <div className="absolute top-full right-0 mt-2 w-56 bg-white rounded-2xl shadow-lg border border-background-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-2 max-h-80 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 cursor-pointer"
                      style={{ fontFamily: 'var(--font-body)' }}
                    >
                      <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                        <i className={`${cat.icon} text-xs`}></i>
                      </div>
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
              <div className="relative group">
                <button
                  className={`flex items-center gap-1.5 text-sm font-medium transition-colors duration-300 cursor-pointer ${
                    isScrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
                  }`}
                  style={{ fontFamily: 'var(--font-label)' }}
                >
                  Niche Guides
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </button>
                <div className="absolute top-full right-0 mt-2 w-64 bg-white rounded-2xl shadow-lg border border-background-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-2 max-h-80 overflow-y-auto">
                  <Link
                    to="/superbuy-spreadsheet-shoes"
                    className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 cursor-pointer"
                    style={{ fontFamily: 'var(--font-body)' }}
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-footprint-line text-xs"></i>
                    </div>
                    Shoes Guide
                  </Link>
                  <Link
                    to="/superbuy-spreadsheet-hoodies"
                    className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 cursor-pointer"
                    style={{ fontFamily: 'var(--font-body)' }}
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-t-shirt-line text-xs"></i>
                    </div>
                    Hoodies Guide
                  </Link>
                  <Link
                    to="/superbuy-spreadsheet-jackets"
                    className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 cursor-pointer"
                    style={{ fontFamily: 'var(--font-body)' }}
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-shirt-line text-xs"></i>
                    </div>
                    Jackets Guide
                  </Link>
                  <Link
                    to="/superbuy-spreadsheet-tshirts"
                    className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 cursor-pointer"
                    style={{ fontFamily: 'var(--font-body)' }}
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-checkbox-blank-circle-line text-xs"></i>
                    </div>
                    T-Shirts Guide
                  </Link>
                  <Link
                    to="/superbuy-spreadsheet-pants"
                    className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 cursor-pointer"
                    style={{ fontFamily: 'var(--font-body)' }}
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-pantone-line text-xs"></i>
                    </div>
                    Pants Guide
                  </Link>
                  <Link
                    to="/superbuy-spreadsheet-jersey"
                    className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 cursor-pointer"
                    style={{ fontFamily: 'var(--font-body)' }}
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-basketball-line text-xs"></i>
                    </div>
                    Jersey Guide
                  </Link>
                  <Link
                    to="/superbuy-spreadsheet-bags"
                    className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 cursor-pointer"
                    style={{ fontFamily: 'var(--font-body)' }}
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-briefcase-line text-xs"></i>
                    </div>
                    Bags Guide
                  </Link>
                  <Link
                    to="/superbuy-spreadsheet-accessories"
                    className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 cursor-pointer"
                    style={{ fontFamily: 'var(--font-body)' }}
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-vip-crown-line text-xs"></i>
                    </div>
                    Accessories Guide
                  </Link>
                  <Link
                    to="/superbuy-spreadsheet-best-finds"
                    className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 cursor-pointer"
                    style={{ fontFamily: 'var(--font-body)' }}
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-fire-line text-xs"></i>
                    </div>
                    Best Finds
                  </Link>
                </div>
              </div>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="whitespace-nowrap inline-flex items-center gap-1.5 px-5 py-2 bg-primary-500 text-white rounded-full font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
                style={{ fontFamily: 'var(--font-label)' }}
              >
                Buy It Now
                <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-xl transition-colors duration-300 cursor-pointer ${
                isScrolled
                  ? 'text-foreground-950 hover:bg-background-100'
                  : 'text-white hover:bg-white/10'
              }`}
              aria-label="Toggle menu"
            >
              <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      <div
        className={`fixed inset-0 z-40 bg-black/50 transition-opacity duration-300 md:hidden ${
          isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>

      <div
        className={`fixed top-0 right-0 z-50 h-full w-80 max-w-[85vw] bg-white transform transition-transform duration-350 ease-out md:hidden overflow-y-auto ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between p-5 border-b border-background-200">
          <span className="font-heading text-lg font-bold text-foreground-950">Menu</span>
          <button
            onClick={() => setIsMobileMenuOpen(false)}
            className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-500 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="p-5 space-y-6">
          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3" style={{ fontFamily: 'var(--font-label)' }}>
              Navigation
            </h4>
            <div className="space-y-1">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-label)' }}
              >
                <i className="ri-home-4-line text-foreground-400"></i>
                Home
              </Link>
              <Link
                to="/superbuy-sheet-guide"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-label)' }}
              >
                <i className="ri-article-line text-foreground-400"></i>
                Complete Guide
              </Link>
              <Link
                to="/superbuy-spreadsheet-review"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-label)' }}
              >
                <i className="ri-star-line text-foreground-400"></i>
                Review
              </Link>
              <Link
                to="/superbuy-spreadsheet-beginner-guide"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-label)' }}
              >
                <i className="ri-user-smile-line text-foreground-400"></i>
                Beginner Guide
              </Link>
              <Link
                to="/superbuy-spreadsheet-best-finds"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-label)' }}
              >
                <i className="ri-fire-line text-foreground-400"></i>
                Best Finds
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3" style={{ fontFamily: 'var(--font-label)' }}>
              Product Categories
            </h4>
            <div className="space-y-0.5">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                  style={{ fontFamily: 'var(--font-body)' }}
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <span>{cat.name}</span>
                  <i className="ri-arrow-right-up-line text-foreground-300 text-xs ml-auto"></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3" style={{ fontFamily: 'var(--font-label)' }}>
              Niche Guides
            </h4>
            <div className="space-y-0.5">
              <Link
                to="/superbuy-spreadsheet-shoes"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-body)' }}
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-footprint-line text-sm"></i>
                </div>
                Shoes Guide
              </Link>
              <Link
                to="/superbuy-spreadsheet-hoodies"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-body)' }}
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className="ri-t-shirt-line text-sm"></i>
                </div>
                Hoodies Guide
              </Link>
              <Link
                to="/superbuy-spreadsheet-jackets"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-body)' }}
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-shirt-line text-sm"></i>
                </div>
                Jackets Guide
              </Link>
              <Link
                to="/superbuy-spreadsheet-tshirts"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-body)' }}
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className="ri-checkbox-blank-circle-line text-sm"></i>
                </div>
                T-Shirts Guide
              </Link>
              <Link
                to="/superbuy-spreadsheet-pants"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-body)' }}
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-pantone-line text-sm"></i>
                </div>
                Pants Guide
              </Link>
              <Link
                to="/superbuy-spreadsheet-jersey"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-body)' }}
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className="ri-basketball-line text-sm"></i>
                </div>
                Jersey Guide
              </Link>
              <Link
                to="/superbuy-spreadsheet-bags"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-body)' }}
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-briefcase-line text-sm"></i>
                </div>
                Bags Guide
              </Link>
              <Link
                to="/superbuy-spreadsheet-accessories"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
                style={{ fontFamily: 'var(--font-body)' }}
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className="ri-vip-crown-line text-sm"></i>
                </div>
                Accessories Guide
              </Link>
            </div>
          </div>

          <div className="pt-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setIsMobileMenuOpen(false)}
              className="whitespace-nowrap w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-primary-500 text-white rounded-full font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
              style={{ fontFamily: 'var(--font-label)' }}
            >
              <i className="ri-shopping-bag-3-line"></i>
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </>
  );
}